/**
 * ----------------------------------------------------------------------------------------
 * Component factory for site-specific components
 * ----------------------------------------------------------------------------------------
 */
/**
 * Map of site IDs to slugs
 * This allows us to convert site IDs to slugs
 */
export const SITE_SLUGS = {
    1: 'volvo', // Default site (Volvista)
    3: 'orbion', // Orbion site
    4: 'cardion', // Cardion site
    5: 'albion', // Albion site
    6: 'lynkac' // Lynkac site
};
/**
 * Get the site-specific component
 * @param {string} componentName - The base name of the component
 * @param {number} siteId - The site ID
 * @param {object} defaultComponent - The default component to use if no site-specific component is found
 * @returns {object} The site-specific component or the default component
 */
export function getSiteSpecificComponent(componentName, siteId, defaultComponent) {
    // If no siteId is provided, return the default component
    if (!siteId) {
        // console.warn(`No site ID provided for ${componentName}, using default component`);
        return defaultComponent;
    }
    // For site ID 1 (volvo), always use the default component
    // as the default components in resources/assets/js/components/CarFilter are for volvo
    if (siteId === 1) {
        // console.log(`Using default component for ${componentName} (site ID: ${siteId} - volvo)`);
        return defaultComponent;
    }
    // Convert site ID to slug
    const siteSlug = SITE_SLUGS[siteId];
    // If we have a slug, try loading from the site-specific directory
    if (siteSlug) {
        try {
            // Try to load from the site-specific directory (e.g., './components/CarFilter/SiteSpecific/orbion/CarFilterTitle.vue')
            const siteSpecificComponent = require(`./components/CarFilter/SiteSpecific/${siteSlug}/${componentName}.vue`).default;
            // console.log(`Loaded site-specific component from directory: ${siteSlug}/${componentName} for site ID ${siteId}`);
            return siteSpecificComponent;
        }
        catch (dirError) {
            // If not found in the directory, return the default component
            // console.log(`No site-specific component found for ${componentName} (site ID: ${siteId}), using default component`);
            return defaultComponent;
        }
    }
    // If we don't have a slug for this site ID, return the default component
    // console.log(`No site slug available for site ID ${siteId}, using default component`);
    return defaultComponent;
}
/**
 * ----------------------------------------------------------------------------------------
 * Create a new Vue application instance.
 * ----------------------------------------------------------------------------------------
 */
import { createApp } from 'vue';
// import { createI18n } from 'vue-i18n';
import CarFilter from './components/CarFilter.vue';
// import cs from '../../../lang/cs.json';
// const i18n = createI18n({
//     legacy: false,
//     locale: 'cs',
//     messages: { cs },
// });
const app = createApp({});
// app.use(i18n);
app.component('car-filter', CarFilter);
app.mount('#car-filter-app');
/**
 * ----------------------------------------------------------------------------------------
 */
